import { cr } from "fire-wind-water";

class Touchs {
  ids = {
    year: "year-wap-picker",
    month: "month-wap-picker",
    date: "date-wap-picker",
    hours: "hours-wap-picker",
    minute: "minute-wap-picker",
    second: "second-wap-picker",
  };
  touchs: any = {};
  select: any = {};

  list: any = {
    year: {
      wap: [],
    },
    month: {
      pc: [],
      wap: [],
    },
    date: {
      wap: [],
    },
    hours: {
      pc: [],
      wap: [],
    },
    minute: {
      pc: [],
      wap: [],
    },
    second: {
      pc: [],
      wap: [],
    },
  };
  constructor() {
    this.getList();
  }

  getList() {
    for (let i = 1900; i < 2200; i++) {
      this.list.year.wap.push(i);
    }
    for (let i = 1; i <= 12; i++) {
      this.list.month.pc.push(i);
      this.list.month.wap.push(i < 10 ? "0" + i : i);
    }
    for (let i = 1; i < 24; i++) {
      this.list.hours.pc.push(i);
      this.list.hours.wap.push(i < 10 ? "0" + i : i);
    }
    for (let i = 1; i < 60; i++) {
      this.list.minute.pc.push(i);
      this.list.minute.wap.push(i < 10 ? "0" + i : i);
      this.list.second.pc.push(i);
      this.list.second.wap.push(i < 10 ? "0" + i : i);
    }
  }

  update(s, o) {
    this.touchs[s] = o;
  }

  setOptions(type, index, t) {
    const selector = `#${this.ids[type]}`;
    this.touchs[type].setOptions(selector, index, t);
  }

  changeIndex(s, i) {
    this.select[s] = parseInt(i, 10);
  }

  changeModel(value) {
    const s = ["year", "month", "date", "hours", "minute", "second"];
    cr.each(s, (d) => {
      if (this.select[d]) {
        value[d] = this.select[d];
      }
    });
  }

  getMonth(year, month) {
    const n = new Date(year, month, 0).getDate();
    this.list.date.wap = [];
    for (let i = 1; i <= n; i++) {
      this.list.date.wap.push(i);
    }
  }
}

export { Touchs };
